import { postJson } from "../utils/postJson";
import { BASE_URL } from "../utils/index";

function credentials() {
  return {
    email: localStorage.getItem("email"),
    idCliente: localStorage.getItem("idCliente"),
  };
}

export async function fetchServiciosSolicitados({
  page = 1,
  perPage = 25,
  search = "",
  sortBy = "fechaServicio",
  sortDirection = "desc",
} = {}) {
  const data = await postJson(`${BASE_URL}/serviciosSolicitados`, {
    ...credentials(),
    page,
    perPage,
    search,
    sortBy,
    sortDirection,
  });

  if (
    !Array.isArray(data.servicios) ||
    !data.pagination ||
    !Number.isInteger(data.pagination.total) ||
    data.pagination.total < 0
  ) {
    throw new Error("El servidor devolvió una lista de servicios inválida.");
  }

  return data;
}

export async function fetchViajesDeServicioSolicitado({
  idServicio,
  origenServicio,
  page = 1,
  perPage = 25,
  search = "",
}) {
  const data = await postJson(`${BASE_URL}/viajesDeServicioSolicitado`, {
    ...credentials(),
    idServicio,
    origenServicio,
    page,
    perPage,
    search,
  });

  if (
    !data.servicio ||
    !Array.isArray(data.viajes) ||
    !data.pagination ||
    !Number.isInteger(data.pagination.total) ||
    data.pagination.total < 0
  ) {
    throw new Error("El servidor devolvió una lista de viajes inválida.");
  }

  return data;
}
